var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{staticClass:"column is-full",attrs:{"message":_vm.hasError ? 'Au moins un champ d\'origine (FR) est vide' : '',"type":_vm.hasError ? 'is-danger' : ''}},[_c('b-button',{attrs:{"label":"Traduire depuis FR","type":"is-primary","loading":_vm.loading,"disabled":_vm.loading || _vm.hasError},on:{"click":_vm.translate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }